import { SearchResult } from '#server/models';
import {
  ResultCard,
  ResultCardDescription,
  ResultCardHeader,
  ResultCardTitle,
  ResultCardLink,
  ResultCardTag,
  Badge,
} from '@/components';
import { cn } from '@/utils';

export interface VideoResultCardProps {
  result: SearchResult;
}

export const VideoResultCard = ({ result }: VideoResultCardProps) => {
  // TODO: Remove defensive checks once mock data is replaced with real API data
  // Handle both API data (nested) and mock data (flat) structures
  const videoDetails = result.videoDetails || {
    url: (result as any).url || '',
    title: (result as any).title || 'Untitled Video',
    description: (result as any).description || '',
    length: (result as any).duration || (result as any).length || '',
  };

  return (
    <ResultCardLink to={videoDetails.url} result={result}>
      <ResultCard className={cn((result.forYou ?? false) && 'border-highlight-border bg-highlight-bg')}>
        <ResultCardHeader>
          <ResultCardTag className="flex items-center">
            {(result.forYou ?? false) && <Badge className="mr-2 bg-ring text-white">For You</Badge>}
            <Badge variant={(result.forYou ?? false) ? 'forYou' : 'secondary'}>Video</Badge>
            <div
              className="relative ml-3 cursor-pointer pl-4 text-xs font-semibold underline underline-offset-2 before:absolute before:left-0
                before:top-1/2 before:h-1 before:w-1 before:-translate-y-1/2 before:rounded-full before:bg-gray-500 before:content-['']"
            >
              {videoDetails.length}
            </div>
          </ResultCardTag>
          <ResultCardTitle>{videoDetails.title}</ResultCardTitle>
          <ResultCardDescription>{videoDetails.description}</ResultCardDescription>
        </ResultCardHeader>
      </ResultCard>
    </ResultCardLink>
  );
};
